import { useQuery } from '@apollo/client';
import { Select, SelectProps } from 'antd';
import { GET_ALL_ROLES } from '../queries';
import { Button, Loading } from '../../../components';
import { RolesData, Role } from '../roles-managment/types';

interface RolesAssigmentFormProps {
  onChange: (value: string[]) => void;
  alredyAssignedRoles?: Role[];
  waiting: boolean;
  onSubmit: () => void;
  errorRoles: any;
}

const RolesAssigmentForm = ({
  onChange,
  onSubmit,
  alredyAssignedRoles,
  waiting,
  errorRoles,
}: RolesAssigmentFormProps) => {
  const { Option } = Select;
  const options: SelectProps['options'] = [];
  const { data, loading, error } = useQuery<RolesData>(GET_ALL_ROLES);

  if (loading || waiting) return <Loading />;
  if (error || errorRoles) return <>Error! ${error?.message || errorRoles}</>;

  const rolesToFilter = alredyAssignedRoles?.map((role) => role.uuid)!;

  if (data) {
    const filteredData = data.findAll.filter(
      (item) => !rolesToFilter.includes(item.uuid)
    );
    filteredData.forEach((role) => {
      options.push({
        label: role.name,
        value: role.uuid,
      });
    });
  }

  return (
    <section className="flex flex-col gap-3">
      <h6>Select roles to assign to this user. </h6>
      <form className="w-full">
        <Select
          className="w-full"
          size="middle"
          placeholder="Select roles"
          onChange={onChange}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          options={options}
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        <div className="flex justify-end  mt-3">
          <Button type="default" onClick={onSubmit}>
            Assign
          </Button>
        </div>
      </form>
    </section>
  );
};

export default RolesAssigmentForm;
